import { useState } from 'react';
import { lt, useDialog } from '@mews/framework';
import { TooltippedIconButton } from '@mews-commander/ui';
import { IconName } from '@optimus-web/icons';
import EntityDeleteDialog from '../../entityManagement/components/EntityDeleteDialog';

interface DialogBackendPageDeleteActionProps {
    entityName?: string;
    onDelete: () => Promise<unknown>;
}

export const DialogBackendPageDeleteAction = ({ onDelete, ...props }: DialogBackendPageDeleteActionProps) => {
    const [{ active, onClose }, toggleDialog] = useDialog();
    const [loading, setLoading] = useState(false);

    const handleConfirmation = async () => {
        try {
            setLoading(true);
            await onDelete();
        } finally {
            setLoading(false);
            onClose();
        }
    };

    return (
        <>
            <TooltippedIconButton
                icon={IconName.Delete}
                size="small"
                variant="ghost"
                onClick={toggleDialog}
                tooltip={lt('Delete')}
                type="button"
            />
            <EntityDeleteDialog
                {...props}
                opened={active}
                onConfirmation={handleConfirmation}
                onCancel={onClose}
                loading={loading}
            />
        </>
    );
};
